import { render, staticRenderFns } from "./NotificacionBalanceResult.vue?vue&type=template&id=87e398fc&scoped=true"
import script from "./NotificacionBalanceResult.vue?vue&type=script&lang=ts"
export * from "./NotificacionBalanceResult.vue?vue&type=script&lang=ts"
import style0 from "./NotificacionBalanceResult.vue?vue&type=style&index=0&id=87e398fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e398fc",
  null
  
)

export default component.exports